export function getLayerTransformCss(rotation: number): string | undefined {
  if (rotation === 0) {
    return undefined;
  }
  return `rotate(-${rotation}deg)`;
}
